import styled from 'styled-components';

const Wrapper = styled.div`
  padding: 0 20px 100px;
`;
const Icon = styled.img`
  width: 100%;
  height: 100%;
`;
const Socials = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 40px;
`;
const Link = styled.a`
  text-decoration: underline;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 85%;
  color: #697B8C;
  &:first-child {
    margin-bottom: 24px;
  }
`;
const Links = styled.div`
  display: flex;
  flex-direction: column;
`;
const Copyright = styled.div`
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 150%;
  color: #000000;
  margin-top: 50px;
`;

const Social = styled.a`
  display: block;
  margin-right: 18px;
  width: 24px;
  height: 24px;
  &:last-child {
    margin-right: 0;
  }
`;

export default {
  Wrapper,
  Icon,
  Socials,
  Links,
  Link,
  Social,
  Copyright,
}
